import { parse } from 'lib/helpers/dateUtils';
import useCopy from 'lib/hooks/useCopy';

import DateInputPicker from 'components/shared/DateInputPicker/DateInputPicker';
import Input from 'components/shared/Input/Input';
import TimePicker from 'components/shared/TimePicker/TimePicker';

const EditTrainingForm = ({ formik, hardGoLiveDate }) => {
  const { copyText, copyToClipboard } = useCopy({ alert: false });

  const handleChangeMeetingDate = (date) => {
    formik.setFieldValue('meetingDate', date);
  };

  const handleChangeStartTime = (time) => {
    formik.setFieldValue('startTime', time);
  };

  const handleChangeEndTime = (time) => {
    formik.setFieldValue('endTime', time);
  };

  const getMaxDate = () => {
    if (!hardGoLiveDate) return undefined;
    if (typeof hardGoLiveDate === 'string') {
      return parse(hardGoLiveDate, 'MM/dd/yyyy', new Date());
    }
    return hardGoLiveDate;
  };

  return (
    <form className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-4">
        <Input
          id="name"
          type="text"
          name="name"
          placeholder=""
          label="Name"
          required
          disabled
          onChange={formik.handleChange}
          value={formik.values.name}
          error={formik.touched.name && formik.errors.name}
        />

        <div className="flex flex-col">
          <p className="pb-1 text-sm">Date</p>
          <DateInputPicker
            type="string"
            placeholder="MM/DD/YYYY"
            onChange={handleChangeMeetingDate}
            value={formik.values.meetingDate}
            error={formik.touched.meetingDate && formik.errors.meetingDate}
            disablePortalContainer
            minDate={new Date()}
            maxDate={getMaxDate()}
          />
          {formik.touched.meetingDate && formik.errors.meetingDate && (
            <p className="mt-1 text-xs text-danger-500">{formik.errors.meetingDate}</p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col">
          <p className="pb-1 text-sm">Start time</p>
          <TimePicker
            customButtonClassName="!hidden"
            className="w-full"
            value={formik.values.startTime}
            onChange={handleChangeStartTime}
          />
          {formik.touched.startTime && formik.errors.startTime && (
            <p className="mt-1 text-xs text-danger-500">{formik.errors.startTime}</p>
          )}
        </div>
        <div className="flex flex-col">
          <p className="pb-1 text-sm">End time</p>
          <TimePicker
            customButtonClassName="!hidden"
            className="w-full"
            value={formik.values.endTime}
            onChange={handleChangeEndTime}
          />
          {formik.touched.endTime && formik.errors.endTime && (
            <p className="mt-1 text-xs text-danger-500">{formik.errors.endTime}</p>
          )}
        </div>
      </div>

      <div className="flex flex-col">
        <p className="pb-1 text-sm">
          Link <span className="text-neutral-500">(Optional)</span>
        </p>
        <Input
          name="meetingLink"
          id="meetingLink"
          placeholder='Enter training link, e.g., "https://zoom.us/j/123456789"'
          value={formik.values.meetingLink}
          error={formik.touched.meetingLink && formik.errors.meetingLink}
          onChange={formik.handleChange}
          {...(formik.values.meetingLink && {
            actionButtonIcon: 'copy-mono',
            actionButtonText: copyText,
            actionButtonClick: () => copyToClipboard(formik.values.meetingLink)
          })}
        />
      </div>
    </form>
  );
};

export default EditTrainingForm;
